import VisualFilter from './VisualFilter';
import EditorsPicks from './EditorsPicks';
import StyleFilter from './StyleFilter';
import PatternFilter from './PatternFilter';
import ColorFilter from './ColorFilter';
import MaterialFilter from './MaterialFilter';
import BrandFilter from './BrandFilter';
import PriceFilter from './PriceFilter';
import PriceRangeFilter from './PriceRangeFilter';
import ProductsList from './ProductsList';
import TotalFound from './TotalFound';
import Pagination from './Pagination';
import FullVisualFilter from './FullVisualFilter';
import TreeViewMenu from './TreeViewMenu';
import CategoryTitle from './CategoryTitle';
import SortBy from './SortBy';
import CategorySelect from './CategorySelect';

import SortBySelect from './SortBySelect';
import PageSizeSelect from './PageSizeSelect';
import PageSize from './PageSize';

import CollapsibleFilters from './CollapsibleFilters';
import PriceFromToFilter from './PriceFromToFilter';
import SimpleCategoriesList from './SimpleCategoriesList';
import SimpleOccasionsList from './SimpleOccasionsList';
import SizeFilter from './SizeFilter';
import DiscountsFilter from './DiscountsFilter';
import ShippingOptionsFilter from './ShippingOptionsFilter';
import Chips from './Chips';
import SimpleVibesList from './SimpleVibesList';
import WashFilter from './WashFilter';
import MaterialTextList from './MaterialTextList';
import MobileTabbedFilters from './MobileTabbedFilters';
import SimplePricesList from './SimplePricesList';
import NewArrivalsFilter from './NewArrivalsFilter';
import BodyPartList from './BodyPartList';
import SaleCheckbox from './SaleCheckbox';
import DynamicList from './DynamicList';
import DynamicRangeFilter from './DynamicRangeFilter';

const widgets = {
  VisualFilter,
  EditorsPicks,
  StyleFilter,
  PatternFilter,
  ColorFilter,
  MaterialFilter,
  BrandFilter,
  PriceFilter,
  PriceRangeFilter,
  ProductsList,
  TotalFound,
  Pagination,
  FullVisualFilter,
  TreeViewMenu,
  CategoryTitle,
  SortBy,
  CategorySelect,
  BodyPartList,

  SortBySelect,
  CollapsibleFilters,
  PriceFromToFilter,
  SimpleCategoriesList,
  SimpleOccasionsList,
  SizeFilter,
  DiscountsFilter,
  ShippingOptionsFilter,
  Chips,
  SimpleVibesList,
  WashFilter,
  MaterialTextList,
  MobileTabbedFilters,
  SimplePricesList,
  NewArrivalsFilter,
  SaleCheckbox,

  PageSizeSelect,
  PageSize,
  DynamicList,
  DynamicRangeFilter,
}

export default widgets;
